"use client";
import styled from "styled-components";
import Image from "next/image";
import {useEffect, useState} from "react";
import blur from '@/public/images/static/blur.jpg'
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import useDeviceTypeTab from "@/components/hooks/useDeviceTypeTab";
gsap.registerPlugin(ScrollTrigger);

export const Img = ({
                        src,
                        srcSm,
                        position,
                        objectFit,
                        height,
                        width,
                        alt,
                        left,
                        margin,
                        right,
                        top,
                        bottom,
                        transition,
                        parallax,
                        parallaxSpeed,
                        responsive,
                        backgroundSize,
                        quality,
                        priority
                    }) => {

    const [deviceWidth, setDeviceWidth] = useState(0);
    // Pixel GIF code adapted from https://stackoverflow.com/a/33919020/266535
    const keyStr =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    // set device width

    const isMobile = useDeviceTypeTab()

    useEffect(() => {
        function HandleWidth() {
            setDeviceWidth(window.innerWidth)
        }

        window.addEventListener('resize', HandleWidth)
        HandleWidth()
        return () => {
            window.removeEventListener('resize', HandleWidth)
        };
    },[]);


    const triplet = (e1, e2, e3) =>
        keyStr.charAt(e1 >> 2) +
        keyStr.charAt(((e1 & 3) << 4) | (e2 >> 4)) +
        keyStr.charAt(((e2 & 15) << 2) | (e3 >> 6)) +
        keyStr.charAt(e3 & 63);
    const rgbDataURL = (r, g, b) =>
        `data:image/gif;base64,R0lGODlhAQABAPAA${
            triplet(0, r, g) + triplet(b, 255, 255)
        }/yH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==`;


    return (
        <StyledImg className={`${parallax ? 'img-container' : ''} global-image`} objectFit={objectFit} margin={margin}
                   position={position} left={left}
                   right={right} top={top} responsive={responsive}
                   bottom={bottom} height={height} width={width} transition={transition}>
            {
                parallax ?

                    !isMobile ?
                    <Image data-scroll data-scroll-speed="-1"  responsive={responsive} loading='lazy' height={height} width={width} quality={quality ? quality : 100} priority={priority ? priority : false} data-speed={parallaxSpeed ? parallaxSpeed : 'auto'} blurDataURL={rgbDataURL(40, 50, 66)} placeholder={"blur"}
                           alt={alt ? alt : src} objectFit={backgroundSize ? backgroundSize : 'cover'} layout={'fill'}
                           src={typeof src === 'string' ? (deviceWidth > 600 ? src : (typeof srcSm === 'string' ? srcSm : src)) : blur}/>
                        :
                        <Image responsive={responsive} loading='lazy' height={height} width={width} quality={quality ? quality : 100} priority={priority ? priority : false} blurDataURL={rgbDataURL(40, 50, 66)} placeholder={"blur"}
                           alt={alt ? alt : src} objectFit={backgroundSize ? backgroundSize : 'cover'} layout={'fill'}
                           src={typeof src === 'string' ? (deviceWidth > 600 ? src : (typeof srcSm === 'string' ? srcSm : src)) : blur}/>

                    :
                    <Image responsive={responsive} loading='lazy' height={height} width={width} quality={quality ? quality : 100} priority={priority ? priority : false} blurDataURL={rgbDataURL(40, 50, 66)} placeholder={"blur"}
                           alt={alt ? alt : src} objectFit={backgroundSize ? backgroundSize : 'cover'} layout={'fill'}
                           src={typeof src === 'string' ? (deviceWidth > 600 ? src : (typeof srcSm === 'string' ? srcSm : src)) : blur}/>
            }

        </StyledImg>
    );
};

const StyledImg = styled.div`
    position: ${props => props.position || 'absolute'};
    height: ${props => props.height || '100%'};
    width: ${props => props.width || '100%'};
    top: ${props => props.top || 0};
    left: ${props => props.left || 0};
    bottom: ${props => props.bottom || 0};
    right: ${props => props.right || 0};
    margin: ${props => props.margin || 0};
    overflow: hidden;

    img {
        ${props => props.transition && `transition: 1.4s ease`} //transition: 1.4s ease;
    }

    .img-container {
        width: 100%;
        padding-top: 80%;
        position: relative;
        overflow: hidden;
        border-radius: 32px;

        img {
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%) scale(1.4);
            transform-origin: 50% 50%;
        }
    }

`;
